<template lang="html">
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Tags
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="dialog=true;"
            >
              Crear nuevo tag
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="getTags()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__info" style="padding: 0px">
      <div class="offer_elements__category--row_container pt-0">
        <template v-for="tag in tags">
          <v-hover>
          <div slot-scope="{ hover }" :key="tag.attributes.name" @click="$router.push({name: 'tag_edit', params: {id: tag.id}})"
          :class="hover?'offer_elements__interaction--hover':''" class="offer_elements__category--row pl-4" >
            <p  class="offer_elements__category--row_title">{{ tag.attributes.natural_name }}</p>
            <v-icon     @click.stop="deleteTag(tag.id)" >delete</v-icon>
          </div>
          </v-hover>
        </template >
      </div>
    </div>
    <v-dialog v-model="dialog" persistent max-width="424px">

      <v-card style="border-radius: 10px;">
				<div class="invitation__new">
				  <div class="invitation__new--title">
					<p class="invitation__new_text--title">Crear tags</p>
				  </div>
				  <div class="invitation__new--info_container">

            <span class="table_card__info--label">Nombre</span>
            <input
              class="faccess_input mb-0"
              type="text"
              placeholder="Ingresar nombre"
              v-model="tag.attributes.natural_name"
            >

					  <div class="invitation__new--actions offer_elements__tag--modal_button_container">
						  <p class="invitation__buttons--blue" @click="createTag()">CREAR</p>
						  <p class="invitation__buttons--gray" @click="dialog=false; ">CANCELAR</p>

					  </div>
					</div>
				</div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      dialog:false,
      tags:[],
      tag:{
        attributes:{
          natural_name: '',
          published: true
        }
      }
    }
  },
  methods:{
    createTag(){
      if(this.tag.attributes.natural_name != '' &&
         this.tag.attributes.natural_name != undefined &&
         this.tag.attributes.natural_name != null){
        try {
          this.$http.post('tags', {data: this.encrypt(this.tag).toString()},
            {headers:
              {"X-Device-ID" : this.getDeviceId(),
               "Authorization" : 'Bearer ' + this.getUserToken()}})
          .then(function(response){
            this.dialog=false;
            this.getTags();
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            // alert(response);
          })
        } catch (e) {
          alert(e.message)
        }
      }
    },
    deleteTag(id){
      try {
        this.$http.delete('tags/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          for (var i = 0; i < this.tags.length; i++) {
            if(this.tags[i].id == id){
              this.tags.splice(i, 1)
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    getTags(){
      try {
        this.$http.get('tags',)
        .then(function(response){
          this.tags = response.body.data
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
        } catch (e) {
          alert(e.message)
        }
    }
  },
  mounted(){
    this.getTags();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/tags/Index.vue